<template>
    <v-main class='pb-0'>
        <div class="main-header">
            <v-img
                src="../assets/usa 250 transparent.jpg" 
                alt="USA Map"
                height="250" 
                contain>
                <v-container fluid>
                <v-layout fill-height>
                <v-flex xs12 align-end flexbox mt-15 header text-lg-h3 text-sm-h3>
                    <p>National</p>
                    <p>DME Compliance Software</p>
                </v-flex>
                </v-layout>
                </v-container>
            </v-img>    
        </div>
    </v-main>
</template>

<script>
export default {
    
}
</script>

<style>
    .main-header {
        height: 300px;
        background-color: #72a7d3;
        border-radius: 5px;
    }

    .header {
        /* color: #ffa831; */
        color: white;
        text-align: center;
    }    
</style>